import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-resumen",
  templateUrl: "./resumen.component.html",
})
export class ResumenComponent implements OnInit {
  @Input()
  get resumen(): any {
    return this._resumen;
  }
  set resumen(resumen: any) {
    this._resumen = resumen === undefined ? null : resumen;
  }
  private _resumen = null;
  constructor() {}

  ngOnInit(): void {}
}
